import { cadCurrencyFormat } from "./constants";

export const EMPTY_SUMMARY_VALUE = "—";

export function formatAverageUnitPrice(quarterlySummaryStats) {
  const priceHistoryRowCount = quarterlySummaryStats?.priceHistoryRowCount ?? 0;
  if (!priceHistoryRowCount) return EMPTY_SUMMARY_VALUE;

  const averageNationalUnitPrice = quarterlySummaryStats?.averageNationalUnitPrice;
  if (averageNationalUnitPrice == null || !Number.isFinite(averageNationalUnitPrice)) {
    return EMPTY_SUMMARY_VALUE;
  }
  return cadCurrencyFormat.format(averageNationalUnitPrice);
}

export function formatDataPointsInPeriod(quarterlySummaryStats) {
  const priceHistoryRowCount = quarterlySummaryStats?.priceHistoryRowCount ?? 0;
  if (!priceHistoryRowCount) return EMPTY_SUMMARY_VALUE;
  return String(priceHistoryRowCount).toLocaleString();
}

export function formatProvinceSummary(provinceSummary) {
  if (!provinceSummary) return EMPTY_SUMMARY_VALUE;
  const { displayName, avgUnitPrice } = provinceSummary;
  if (!displayName || avgUnitPrice == null || !Number.isFinite(avgUnitPrice)) {
    return EMPTY_SUMMARY_VALUE;
  }
  return `${displayName} — ${cadCurrencyFormat.format(avgUnitPrice)}`;
}

export function shouldShowProvinceComparisonCards({ selectedProvince, selectedRetailers = [] }) {
  return selectedProvince == null && selectedRetailers.length === 0;
}

/**
 * @param {{
 *   quarterlySummaryStats?: object,
 *   selectedProvince?: object | null,
 *   selectedRetailers?: { name?: string }[],
 * }} params
 * @returns {{ key: string, label: string, value: string }[]}
 */
export function buildPricingReportSummaryCards({
  quarterlySummaryStats,
  selectedProvince = null,
  selectedRetailers = [],
}) {
  const showProvinceComparisonCards = shouldShowProvinceComparisonCards({
    selectedProvince,
    selectedRetailers,
  });

  const cards = [
    {
      key: "average-unit-price",
      label: "Average unit price",
      value: formatAverageUnitPrice(quarterlySummaryStats),
    },
    {
      key: "data-points-in-period",
      label: "Data points",
      value: formatDataPointsInPeriod(quarterlySummaryStats),
    },
  ];

  if (showProvinceComparisonCards) {
    cards.push(
      {
        key: "lowest-avg-price-province",
        label: "Lowest province",
        value: formatProvinceSummary(quarterlySummaryStats?.lowestProvince ?? null),
      },
      {
        key: "highest-avg-price-province",
        label: "Highest province",
        value: formatProvinceSummary(quarterlySummaryStats?.highestProvince ?? null),
      }
    );
  }

  return cards;
}

export function summaryCardGridMdSize(cardCount) {
  if (cardCount <= 0) return 12;
  return 12 / cardCount;
}
